var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00097 7.06061L10.2437 11.3034C10.3852 11.44 10.5746 11.5156 10.7713 11.5139C10.9679 11.5122 11.156 11.4333 11.2951 11.2942C11.4341 11.1552 11.513 10.9671 11.5147 10.7704C11.5164 10.5738 11.4408 10.3843 11.3042 10.2429L7.06147 6.00011L11.3042 1.75736C11.4408 1.61591 11.5164 1.42646 11.5147 1.22981C11.513 1.03316 11.4341 0.845054 11.2951 0.705998C11.156 0.566942 10.9679 0.488065 10.7713 0.486356C10.5746 0.484648 10.3852 0.560243 10.2437 0.696862L6.00097 4.93961L1.75822 0.696862C1.61613 0.563621 1.42778 0.490886 1.23301 0.494049C1.03825 0.497211 0.85236 0.576023 0.714673 0.713807C0.576986 0.851592 0.498306 1.03754 0.495281 1.2323C0.492256 1.42707 0.565124 1.61537 0.698466 1.75736L4.94047 6.00011L0.697716 10.2429C0.626083 10.312 0.568947 10.3948 0.52964 10.4863C0.490333 10.5778 0.469644 10.6762 0.468778 10.7758C0.467913 10.8754 0.486889 10.9742 0.5246 11.0663C0.56231 11.1585 0.618 11.2422 0.68842 11.3127C0.758839 11.3831 0.842578 11.4388 0.934751 11.4765C1.02692 11.5142 1.12568 11.5332 1.22527 11.5323C1.32485 11.5314 1.42327 11.5107 1.51477 11.4714C1.60627 11.4321 1.68903 11.375 1.75822 11.3034L6.00097 7.06061Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.6b8b280a196e8dceaf8f4a6a80c9ac65.svg";
export { ForwardRef as ReactComponent };